import Link from 'next/link'
import styles from './style.module.scss'

export const BacktoTopButton = () => {
  return (
    <Link href="/" className={styles.backtoTopButton}>
      TOPへ戻る
    </Link>
  )
}

export default BacktoTopButton
